define(['whatwg-fetch'], function() {
    return window.fetch;
});
